import React from 'react';
import { Icon } from './index';

const SkholeIcon19 = Icon(
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 40 40"
    style={{ enableBackground: 'new 0 0 40 40' }}
    xmlSpace="preserve"
  >
    <g>
      <defs>
        <path
          id="SVGID_3_"
          d="M20,4.5C11.5,4.5,4.5,11,4.5,18.9V19c0,4.5,0,9.2,4.6,11c0.2,3.3,2.2,5.4,5.3,5.4c0.6,0,1.2-0.1,1.8-0.2
			c0.5-0.1,0.9-0.6,0.9-1.1v-9c0-0.5-0.4-1-0.9-1.1c-0.6-0.2-1.2-0.2-1.8-0.2c-2.6,0-4.4,1.5-5.1,3.8C7,26.3,6.9,23.4,6.9,19v-0.1
			c0-6.7,5.9-12.1,13.1-12.1s13.1,5.4,13.1,12.1V19c0,4.3-0.1,7.3-2.5,8.6c-0.6-2.4-2.5-3.9-5.1-3.9c-0.6,0-1.2,0.1-1.8,0.2
			c-0.5,0.1-0.9,0.6-0.9,1.1v9c0,0.5,0.4,1,0.9,1.1c0.6,0.2,1.2,0.2,1.8,0.2c3.1,0,5.2-2.1,5.3-5.4c4.6-1.8,4.6-6.7,4.6-11v-0.1
			C35.5,11,28.5,4.5,20,4.5 M14.4,26.1c0.1,0,0.2,0,0.3,0v7.1c-0.1,0-0.2,0-0.3,0c-2.7,0-3-2.5-3-3.6C11.5,28.6,11.8,26.1,14.4,26.1
			 M25.5,33.2c-0.1,0-0.2,0-0.3,0v-7.1c0.1,0,0.2,0,0.3,0c2.7,0,3,2.5,3,3.6C28.5,30.7,28.2,33.2,25.5,33.2"
        />
      </defs>
      <use
        xlinkHref="#SVGID_3_"
        style={{
          overflow: 'visible',
          fillRule: 'evenodd',
          clipRule: 'evenodd',
        }}
      />
      <clipPath id="SVGID_2_">
        <use xlinkHref="#SVGID_3_" style={{ overflow: 'visible' }} />
      </clipPath>
      <rect x="-2.2" y="-2.2" height="44.5" />
    </g>
  </svg>,
);

export default SkholeIcon19;
